exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".balance-wrapper .delete-balance[data-v-1d7905a9]{display:none}.balance-wrapper:hover .delete-balance[data-v-1d7905a9]{display:block}", ""]);

// exports
